import { useMemo } from 'react'

import { useApiClient } from 'clients/yogi-api'
import { DashboardV2Service } from 'features/dashboards-v2/service/service'

export { DashboardV2Service } from 'features/dashboards-v2/service/service'

export function useDashboardV2Service(): DashboardV2Service {
  const client = useApiClient()
  return useMemo(() => new DashboardV2Service(client), [client])
}
